export const stateRates = [
  { state: 'AK', rate: '$50' },
  { state: 'AL', rate: '$40' },
  { state: 'AR', rate: '$46' },
  { state: 'AZ', rate: '$44' },
  { state: 'CA', rate: '$58' },
  { state: 'CO', rate: '$42' },
  { state: 'CT', rate: '$63' },
  { state: 'DC', rate: '$60' },
  { state: 'DE', rate: '$46' },
  { state: 'FL', rate: '$43' },
  { state: 'GA', rate: '$50' },
  { state: 'HI', rate: '$50' },
  { state: 'IA', rate: '$48' },
  { state: 'ID', rate: '$50' },
  { state: 'IL', rate: '$49' },
  { state: 'IN', rate: '$47' },
  { state: 'KS', rate: '$47' },
  { state: 'KY', rate: '$42' },
  { state: 'LA', rate: '$43' },
  { state: 'MA', rate: '$58' },
  { state: 'MD', rate: '$52' },
  { state: 'ME', rate: '$50' },
  { state: 'MI', rate: '$45' },
  { state: 'MN', rate: '$53' },
  { state: 'MO', rate: '$45' },
  { state: 'MS', rate: '$36' },
  { state: 'MT', rate: '$50' },
  { state: 'NC', rate: '$43' },
  { state: 'ND', rate: '$50' },
  { state: 'NE', rate: '$47' },
  { state: 'NH', rate: '$54' },
  { state: 'NJ', rate: '$50' },
  { state: 'NM', rate: '$46' },
  { state: 'NV', rate: '$45' },
  { state: 'NY', rate: '$61' },
  { state: 'OH', rate: '$49' },
  { state: 'OK', rate: '$40' },
  { state: 'OR', rate: '$46' },
  { state: 'PA', rate: '$53' },
  { state: 'RI', rate: '$57' },
  { state: 'SC', rate: '$49' },
  { state: 'SD', rate: '$54' },
  { state: 'TN', rate: '$42' },
  { state: 'TX', rate: '$41' },
  { state: 'UT', rate: '$42' },
  { state: 'VA', rate: '$51' },
  { state: 'VT', rate: '$51' },
  { state: 'WA', rate: '$49' },
  { state: 'WI', rate: '$48' },
  { state: 'WV', rate: '$44' },
  { state: 'WY', rate: '$50' },
];
